import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { AuthService } from '../../_services/authentication.service';
import { CharacterSheetService } from '../../_services/character-sheet.service';
import { Joueur } from '../../_models/joueur';
import { CommandResult } from 'src/app/_models/commandResult';
import { UpdateJoueurCommand } from 'src/app/_models/_commands/createPersonnageCommand';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.update.component.html',
  styleUrls: ['./dashboard.update.component.scss'],
})
export class DashboardUpdateComponent implements OnInit {
  dashboardForm!: FormGroup;
  joueur!: Joueur;
  submitted: boolean = false;

  constructor(private formBuilder: FormBuilder, public authService: AuthService, private characterSheetService: CharacterSheetService, private router:Router) {}
  ngOnInit(): void {
    
    this.characterSheetService.getJoueur()          
    .pipe(first())
    .subscribe({
      next: (joueur) => {
        this.joueur = joueur;
        this.initializeDashboardForm();2
      }
    });
  }
  
  initializeDashboardForm() {
    this.dashboardForm = this.formBuilder.group({
      nomComplet: [this.joueur.nomComplet],
      adresse: [this.joueur.adresse],
      telephone: [this.joueur.telephone],
      dateDeNaissance: [this.joueur.dateDeNaissance ? formatDate(this.joueur.dateDeNaissance, 'yyyy-MM-dd', 'en') : ''],
      contactNomComplet: [this.joueur.contactUrgence?.nomComplet],
      contactRelation: [this.joueur.contactUrgence?.relation],
      contactNumero: [this.joueur.contactUrgence?.numero],
      autreInformation: [this.joueur.autreInformation]
    });
  }

  onSubmit() {
    this.submitted = true;
    const command = this.dashboardForm.value;
    this.characterSheetService.updateJoueur(command)
    .pipe(first())
    .subscribe({
      next: (commandResult: CommandResult) =>
      {
        console.log(commandResult);
        this.router.navigateByUrl(`/dashboard`);
      }
    }); 
  }
}